import React from 'react'
import './student-onboarding-task-card.css'
import { truncate } from '../../Calendar/calendarFunctions'

const StudentOnboardingTaskCard = (props) => {
    const [ownerPic, setOwnerPic] = React.useState('')
    const [callNow, setCallNow] = React.useState(false)
    const [allScheduled, setAllscheduled] = React.useState(false)
    React.useEffect(() => {
        if(props.todo.todoOwner === 'Courtney') {
            setOwnerPic('https://app.atharo.app/courtneymalloy.jpg')
        } else if (props.todo.todoOwner === 'Bri') {
            setOwnerPic('https://app.atharo.app/brimassie.jpg')
        } else {
            setOwnerPic('./mmalogo.png')
        }
    }, [])

    React.useEffect(() => {
        setCallNow(false)
        setAllscheduled(false)
        if(props.todo.studentList) {
            let notSched = false
            if(props.todo.studentList.length === 0) {
                notSched = true
            }
            for(let i = 0; i < props.todo.studentList.length; i++) {
                if(!props.todo.studentList[i].introLesson.isScheduled) {
                    notSched = true
                }
            }
            notSched ? setAllscheduled(false) : setAllscheduled(true)
        }
    }, [props.todo.studentList])

    const studentOnboardTaskCardStyleSettings = () => {
        let optBorderColor = '2px solid white'
        if(props.todo.whichList === 'orange') {
            optBorderColor = '2px solid orange' 
    }
        else if (props.todo.whichList === 'blue') {
            optBorderColor = '2px solid blue' 
    }
        let shouldFlash = false
        if(props.todo.studentList) {
            for(let i = 0; i < props.todo.studentList.length; i++) {
                if((new Date() > new Date(props.todo.studentList[i].introLesson.date) && props.todo.studentList[i].introLesson.isScheduled)) {
                    if(!props.todo.studentList[i].introLesson.hasBeenCalled) {
                        shouldFlash = true
                    }
                }
            }
        }
        if(shouldFlash) {
            return {animationIterationCount: 'infinite', backgroundColor: 'rgba(255, 128, 0, 0.4)'} 
        }
        if(props.todo.todoAlarm && !props.todo.theyHaveBeenCalled) {
            return {animationIterationCount: 'infinite', backgroundColor: 'rgba(255, 128, 0, 0.5)'}
        } else if (props.todo.todoAlarm && props.todo.theyHaveBeenCalled) {
            return {border: optBorderColor , animationIterationCount: '0', backgroundColor: 'rgba(0, 128, 0, 0.42)'}
        } else {
            return {border: optBorderColor, animationIterationCount: '0'}
        }
    }

    const websiteInquiryCallStyleSettings = () => {
        if(props.todo.todoAlarm && !props.todo.theyHaveBeenCalled) {
            return {animationIterationCount: 'infinite', backgroundColor: 'rgba(255, 128, 0, 0.5)'}
        } else if (props.todo.todoAlarm && props.todo.theyHaveBeenCalled) {
            return {border: '2px solid green', animationIterationCount: '0', backgroundColor: 'rgba(0, 128, 0, 0.42)'}
        } else {
            return {animationIterationCount: '0'}
        }
    }

        if (props.todo.whichList === 'inquiry') {
            return(
                <div className='student-onboarding-task-card' id={`${props.todo.todoId}`} style={websiteInquiryCallStyleSettings()} onClick={() => props.openModal(props.todo)}>
                    <div className='student-onboarding-task-card__name'>{truncate(props.todo.todoName, 20)}</div>
                    <div className='student-onboarding-task-card__tasks'>{(props.todo.todoSubtasks.filter(task => !task.subtaskCompleted && task )).length}</div>
                    {props.todo.instrumentList && <div className='student-onboarding-task-card__insts__wrapper'>{props.todo.instrumentList.map((inst) => <div key={inst.id} className='student-onboarding-task-card__inst'>{inst.name}</div>)}</div>}
                    <img alt='card-owner' className='student-onboarding-task-card__image' src={ownerPic} />
                </div>
            )
        } else {
            return(
                <div className='student-onboarding-task-card' id={`${props.todo.todoId}`} style={studentOnboardTaskCardStyleSettings()} onClick={() => props.openModal(props.todo)}>
                    <div className='student-onboarding-task-card__name'>{truncate(props.todo.todoName, 20)}</div>
                    <div className='student-onboarding-task-card__tasks'>{(props.todo.todoSubtasks.filter(task => !task.subtaskCompleted && task )).length}</div>
                    {props.todo.studentList && <div className='student-onboarding-task-card__student-number' style={allScheduled ? {backgroundColor: 'rgba(0, 128, 0, 0.42)', color: 'green', border: '1px solid green'} : {backgroundColor: 'rgba(255, 166, 0, 0.424)', color: 'rgb(137, 89, 0)', border: '1px solid rgba(255, 166, 0, 0.424)'}} >{props.todo.studentList.length}</div>}
                    {props.todo.instrumentList && <div className='student-onboarding-task-card__insts__wrapper'>{props.todo.instrumentList.map((inst) => <div key={inst.id} className='student-onboarding-task-card__inst'>{inst.name}</div>)}</div>}
                    <img alt='card-owner' className='student-onboarding-task-card__image' src={ownerPic} />
                </div>
            )
        } 
}
export default StudentOnboardingTaskCard